import { StateCreator } from 'zustand';
import {
  AaeResponseDto,
  AarDraftResponseDto,
  CapResponseDto,
  CcaPcaResponseDto,
  FaeResponseDto,
  FnpDraftResponseDto,
  ParResponseDto,
} from '../../types';
import { createFunctionalSetter } from '../storeCommons';
import { cutOffInitialState, CutOffState } from './cutOffInitialState';

/**
 * @french
 * Interface des actions liées à la gestion CCA/PCA.
 */
export interface CutOffActions {
  setQueryParams: (
    updater:
      | CutOffState['queryParams']
      | ((prev: CutOffState['queryParams']) => CutOffState['queryParams']),
  ) => void;
  setSelectedCcaPca: (ccaPca: CcaPcaResponseDto | null) => void;
  setIsUpdateModalVisible: (visible: boolean) => void;
  setDeleteModalVisibility: (
    visible:
      | 'hidden'
      | 'showFnp'
      | 'showAar'
      | 'showCcaPca'
      | 'showFae'
      | 'showAae'
      | 'showPar'
      | 'showCap',
  ) => void;
  setSelectedRecord: (record: CcaPcaResponseDto | null) => void;
  setSelectedFnp: (record: FnpDraftResponseDto | null) => void;
  setSelectedAar: (record: AarDraftResponseDto | null) => void;
  setSelectedFae: (record: FaeResponseDto | null) => void;
  setSelectedAae: (record: AaeResponseDto | null) => void;
  setSelectedPar: (record: ParResponseDto | null) => void;
  setSelectedCap: (record: CapResponseDto | null) => void;
  reset: () => void;
}

/**
 * @french
 * Slice Zustand pour la gestion du CCA/PCA.
 */
export const createCutOffSlice: StateCreator<CutOffState & CutOffActions, [], [], CutOffActions> = (
  set,
  get,
) => ({
  // Setter pour les paramètres de requête
  setQueryParams: createFunctionalSetter(get, set, 'queryParams'),

  // Définit le CCA/PCA sélectionné
  setSelectedCcaPca: (ccaPca) => set({ selectedCcaPca: ccaPca }),

  // Contrôle la visibilité du modal de mise à jour
  setIsUpdateModalVisible: (visible) => set({ isUpdateModalVisible: visible }),

  // Contrôle la visibilité du modal de suppression
  setDeleteModalVisibility: (visible) =>
    set({
      deleteModalVisibility: visible,
    }),

  // Définit l’enregistrement actuellement sélectionné pour édition ou suppression
  setSelectedRecord: (record) => set({ selectedRecord: record }),
  setSelectedFnp: (record) => set({ selectedFnp: record }),
  setSelectedAar: (record) => set({ selectedAar: record }),
  setSelectedFae: (record) => set({ selectedFae: record }),
  setSelectedAae: (record) => set({ selectedAae: record }),
  setSelectedCap: (record) => set({ selectedCap: record }),
  setSelectedPar: (record) => set({ selectedPar: record }),

  // Réinitialise l’état complet à sa valeur initiale
  reset: () => set(cutOffInitialState),
});
